import logoImage from "../../assest/images/logo-img.png"
import { Link } from "react-router-dom";
import LastBox from "../../components/LastBox";
import ReCAPTCHA from 'react-google-recaptcha';
import whiteLogoImage from "../../assest/images/whitelogo.png";


const Index = ({
    state,
    sendMail,
    changeValue,
    isLoading,
    setRecaptchaToken,
    resetRecaptcha,
    recaptchaRef,
    userlang
}) => {
    const { error, email } = state;
    return (
        <section className="loginSec">
            <div className="loginpart">
                <div className="container">
                    <div className="loginBox">
                        <div className="logoSec">
                            {/* <Link to={'/'}><img src={logoImage} alt="logo-img" /></Link> */}
                            <Link to={'/' + userlang} className='comLogo'>
                                <img src={logoImage} alt="logo-img" />
                            </Link>
                            <Link to={'/' + userlang} className='whitelogo'><img src={whiteLogoImage} alt="logo-img" /></Link>
                            <h4>Forgot your password? <br /> Let's help you reset it.</h4>
                        </div>
                        <form onSubmit={sendMail}>
                            <div className="fillDetails">
                                <ul>
                                    <li>
                                        <label className="commonLabel" htmlFor="">Email</label>
                                        <input className="commonInput" type="email" name="email" value={email} placeholder="Enter email" onChange={changeValue} />
                                        {error && error.email && <span className="cus-err">{error.email}</span>}
                                    </li>

                                    <li>
                                        <div className="reg-g-captcha-main">
                                            {/* <ReCAPTCHA
                                                ref={recaptchaRef}
                                                sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}
                                                onChange={(token) => setRecaptchaToken(token)}
                                                onExpired={(e) => resetRecaptcha(e)}
                                            // size="invisible"
                                            /> */}
                                            {/* <div className="g-recaptcha" ref={recaptchaRef}></div> */}
                                            {/* <div className="g-recaptcha"
                                                data-sitekey={process.env.REACT_APP_GOOGLE_CAPTCHA_SITE_KEY}  // Replace with your site key
                                                data-callback={(token)=>console.log(token)}
                                                ref={recaptchaRef}></div> */}
                                            {error && error.recaptchaToken && <span className="cus-err mt-1">{error.recaptchaToken}</span>}
                                        </div>
                                    </li>

                                </ul>
                                <div className="remember">
                                    <div className="loginBtn">
                                        <button
                                            className="btn common-btn btn-login"
                                            type="submit"
                                            disabled={isLoading}>

                                            {isLoading ? "Loading..." : "Send Mail"}
                                            {!isLoading && <i className="fa-solid fa-chevron-right"></i>}
                                        </button>
                                    </div>
                                    <div className="register">
                                        <p>Back To<Link className="comYellowa" to={'/en/login'}>Login</Link></p>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <LastBox  userlang={userlang} />
                </div>
            </div>
        </section>
    )

}
export default Index;
